











































import Component, { mixins } from 'vue-class-component'
import Card from '@/components/Card.vue'
import Switcher from '@/components/Switcher.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/classes/User'
import Api from '@/api'
import { ESortOrder, EUserPermissions, IStatement } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ScrollView from '@/components/ScrollView.vue'
import { StatementModule } from '@/store/modules/statement.module'
import Icon from '@/components/Icon.vue'
import { ERecipientType } from '@zunta/configurations/dist/types/resident'
import NoData from '@/views/app/management/residents/NoData.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import StatusStatement from '@/components/statuses/StatusStatement.vue'
import { ResidentPageMixin } from '@/views/app/management/residents/resident-page/ResidentPageMixin'

@Component({
  components: { StatusStatement, DateTimeLabel, NoData, Icon, ScrollView, LoaderWrapper, Switcher, Card }
})
export default class ResidentStatementWidget extends mixins(ResidentPageMixin) {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  user: User = Api.getUser() as User
  isLoading: boolean = false

  get deliveryMethodIcon () {
    return (type: ERecipientType) => {
      switch (type) {
        case ERecipientType.EMAIL:
          return 'email'
        case ERecipientType.ROOM:
          return 'home'
        case ERecipientType.MAIL:
          return 'envelope'
        default:
          return ''
      }
    }
  }

  get residentId () {
    return this.$route.params.id
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get isPermittedToView () {
    return this.user.hasPermissionFor(EUserPermissions.VIEW_MAILINGS)
  }

  get statements (): IStatement[] {
    if (!this.$store.state.statement.statementList || !this.$store.state.statement.statementList.length) {
      return []
    }
    return this.$store.state.statement.statementList
  }

  get lastBatchStatements (): IStatement[] {
    return this.statements.filter((statement: IStatement) => statement.batch === this.statements[0].batch)
  }

  mounted () {
    this.fetchData()
    this.$watch('residentId', () => this.fetchData())
  }

  async fetchData () {
    try {
      this.isLoading = true
      await this.statementModuleInstance.getResidentStatementListByFilters({
        residentId: this.residentId,
        filters: {
          limit: '100',
          sortBy: 'number',
          sortOrder: ESortOrder.DESC
        }
      })
    } finally {
      this.isLoading = false
    }
  }

  goToStatement (statement: IStatement) {
    this.$locationManager.rememberAndGoTo({
      name: 'review-statements',
      params: {
        batch: statement.batch.toString(),
        statement: statement.id.toString()
      }
    })
  }
}
